export const TIMEOUT_REDIRECT = 1200;
